var React = require('react');

function FireOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.057 4.595C3.97 6.232 3.085 8.101 3.085 9.844a5.907 5.907 0 0 0 11.813 0c0-3.657-2.531-6.47-4.583-8.517h0L7.867 6.469l-2.81-1.874h0Z","stroke":"#F45A3B","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FireOutline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = FireOutline;

FireOutline.default = FireOutline;
